import { EMPTY_LIST, EMPTY_MAP } from './StepAccess.state';

export const selectAccess = (state) => {
    const { loading, error, loaded } = state.access;
    return { loading, error, loaded };
};

export const selectLoaded = (state) => state.access.loaded;

export const selectPeople = (state) => state.access.data?.people ?? EMPTY_LIST;

export const selectSteps = (state) => state.access.data?.steps ?? EMPTY_LIST;

export const selectEditable = (state) => Boolean(state.access.data?.editable);

export const selectTranslations = (state) => state.access.data?.translations ?? EMPTY_MAP;

export const makeSelectStepState = (stepId) => (state) => ({
    pending: state.pending[stepId] ?? EMPTY_MAP,
    query: state.query[stepId] ?? '',
    directory: state.directory[stepId] ?? EMPTY_LIST,
    searching: Boolean(state.searching[stepId]),
    saving: Boolean(state.saving[stepId]),
});
